import { Box, Image, Text, VStack } from "@chakra-ui/react";
import background from "../../assets/image/p1-bg.png";
import bubble from "../../assets/image/p1-bubble.png";
import mainImg from "../../assets/image/p1-main.gif";

const HeaderPage1 = () => {
    return (
        <>
            <Box>
                <Image
                    src={background} 
                    w="100vw"
                    h="auto"
                    zIndex="-1"
                />
                <Box
                    position="absolute"
                    top="100px"
                    left="5vw"
                    w="90vw"
                >
                    <Image 
                        src={bubble} 
                        w="100%"
                        h="150px"
                        zIndex=""
                        position="absolute"
                    />
                    <VStack
                        spacing="1em"
                        position="absolute"
                        w="100%"
                    >
                        <Text 
                            fontSize="18px"
                            color="black"
                            w="100%"
                            align="center"
                            margin={0}
                            mt="1em"
                        >
                            「咦？你是誰啊？」
                        </Text>
                        <Text 
                            fontSize="16px"
                            color="black"
                            w="80%"
                            left="10%"
                            align="center"
                        >
                            為了讓兔子家族認識你，請告訴我們下列這些封號有多符合你?
                        </Text>
                    </VStack>
                    <Image 
                        src={mainImg} 
                        w="100%"
                        h="auto"
                        zIndex=""
                        mt="9rem"
                    />
                </Box>
            </Box>
        </>
    );
}

export default HeaderPage1;